import React from "react";
import { Typography, Grid, Stack } from "@mui/material";
import { useFormikContext } from "formik";
// import useStyles from './styles';

function PaymentDetails(props) {
  const { values: formValues } = useFormikContext();
  const { firstName, lastName } = formValues;

  return (
    <Grid item xs={12} sm={12}>
    
          <Typography gutterBottom align="left">
            thank you {`${firstName} ${lastName}`} for registering with us, you
            are almost done, check your information and press "submit" to complte your registration
            registration.
          </Typography>
      
      <img height="100vh" width="100vw" alt="" src={props.profilePic} />
    </Grid>
  );
}

export default PaymentDetails;
